<template>
  <iframe class="frame" src="https://quantumjs-9e2ff.web.app" title="JsQuantum Simulator"></iframe>
</template>

<script>
export default {
  name: "Archive"
};
</script>

<style lang="scss">
.frame {
  height: 99vh;
  width: 100vw;
  border: none;
  overflow: hidden;
}
</style>